import React from "react"

import { MEDIA_QUERIES } from "@constants"

const HomeCSS = `
  main {
    h2,
    h3,
    h4,
    h5,
    [class*=type--display-],
    [class*=type--headline-] {
      font-weight: var(--font-weight--medium);
    }

    h1 {
      font-size: var(--font-size--6XL);
      margin-bottom: var(--headline-6XL--margin-bottom);
    }

    h2 {
      font-size: var(--font-size--5XL);
      margin-bottom: var(--headline-5XL--margin-bottom);
    }

    section.LpSection {
      margin-bottom: var(--spacing--2XL);
    }

    .LpSection--subhead span {
      box-shadow: 0 0 0 1px var(--color--charcoal-300);
      border-radius: 9999px;
      padding: 2px 10px 1px;
    }
  }

  /* New Recipe */
  @keyframes NewRecipeGlow {
    0% {
      background-position: 0% 0%;
      translate: 0;
      transform: none;
    }
    25% {
      background-position: 0% 50%;
      translate: -5% 5%;
      transform: scale(1.2, 0.9);
    }
    50% {
      background-position: 50% 50%;
      translate: -5% 5%;
      transform: none;
    }
    75% {
      background-position: 50% 0%;
      translate: 0% -5%;
      transform: scale(1.2, 0.9);
    }
    100% {
      background-position: 0% 0%;
      translate: 0;
      transform: none;
    }
  }
  .BentoBoxBlock.uid--20PkVfVnaCai5xAMrY9z6b h2 span {
    display: inline-block;
    position: relative;
  }
  .BentoBoxBlock.uid--20PkVfVnaCai5xAMrY9z6b h2 span::before {
    animation: NewRecipeGlow 4s linear infinite;
    animation-play-state: paused;
    background: linear-gradient(-45deg, var(--color--purple-accent), var(--color--red-300), var(--color--purple-accent), var(--color--red-300));
    background-size: 400% 400%;
    background-position: 0% 0%;
    border-radius: 100%;
    content: "";
    display: block;
    filter: blur(12px);
    height: 50%;
    left: 14%;
    opacity: 0.48;
    position: absolute;
    top: 35%;
    transition: opacity 1s;
    width: 90%;
    z-index: -1;
  }
  .BentoBoxBlock.uid--20PkVfVnaCai5xAMrY9z6b h2 span:hover::before {
    animation-play-state: running;
    opacity: 0.72;
  }

  /* Inbox Tour Intro */
  .TextBlock.uid--6CRZvuWjbBM4k4IBTRqe5a {
    margin-bottom: var(--spacing--L);
  }

  /* Last three sections on page */
  .TestimonialBlock.uid--68t3clslHyFQNRLXhnJnlT {
    margin-bottom: 0;
  }

  .TestimonialBlock.uid--68t3clslHyFQNRLXhnJnlT .TestimonialBlockScroller {
    padding-bottom: var(--spacing--L);
  }

  .LogosBlock.uid--7eE2FsCsQZl0T7evVG9yqn,
  .BentoBoxBlock.uid--kUzHj14oAYJ4A0UD2po4Y {
    margin-bottom: var(--spacing--XL);
  }
`

const HomeStyle = () => (
  <style dangerouslySetInnerHTML={{ __html: HomeCSS }} />
)

export default HomeStyle
